module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.view.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.adjustment.view.details'),
      "name": "first"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.adjustment.view.detailsLegend')))]), _vm._v(" "), [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.code')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentAdjustment.code) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.warehouse')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'warehouse.edit',
        params: {
          id: _vm.currentAdjustment.warehouse.id
        }
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.currentAdjustment.warehouse.name) + "\n                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.qty')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentAdjustment.total_qty) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.status')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t(("form.adjustment.adjustmentStatus." + (_vm.currentAdjustment.status)))) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.adjustmentType')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t(("form.adjustment.adjustmentTypeList." + (_vm.currentAdjustment.adjustmentType)))) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.reason')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentAdjustment.reason) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.info.createdAt')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentAdjustment.createdAt) + "\n                  ")])])]], 2)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.adjustment.view.products'),
      "name": "products"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.adjustment.view.productsLegend')))]), _vm._v(" "), _c('v-table', {
    attrs: {
      "list": _vm.productList,
      "noDataMessage": _vm.$t('static.adjustment.noData'),
      "translation": "static.adjustment.products"
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a17fb8dc","hasScoped":false}!./src/app/pages/withNavigation/adjustment/view/view.html
// module id = 3100
// module chunks = 1